<template>
  <section class="section section--soft">
    <div class="container">
      <p class="eyebrow">{{ t("extra.eyebrow") }}</p>
      <h2 class="section-title">{{ t("extra.title") }}</h2>
      <p class="section-lead">{{ t("extra.lead") }}</p>
      <div class="extra-grid">
        <article
          v-for="item in extraServices"
          :key="item.id"
          class="extra-card"
          :class="{ 'is-hot': item.highlight }"
        >
          <span v-if="item.highlight" class="hot-badge">{{ t("extra.badge") }}</span>
          <h3>{{ t(`extra.items.${item.id}.title`) }}</h3>
          <p>{{ t(`extra.items.${item.id}.text`) }}</p>
          <div class="price-tag">{{ t(`extra.prices.${item.priceKey}`) }}</div>
          <ul>
            <li v-for="(feature, index) in featureList(item.id)" :key="index">
              <svg class="check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              <span>{{ feature }}</span>
            </li>
          </ul>
          <div class="btn-row">
          <a
            class="btn btn--primary btn--block"
            :href="quoteHref"
            target="_blank"
            rel="noopener"
          >
              {{ t("extra.cta") }}
            </a>
            <a class="btn btn--ghost btn--block" href="#iletisim">
              {{ t("extra.details") }}
            </a>
          </div>
        </article>
      </div>
      <div class="other-box">
        <div>
          <h3>{{ t("extra.otherTitle") }}</h3>
          <p>{{ t("extra.otherText") }}</p>
        </div>
        <a class="btn btn--primary" :href="quoteHref" target="_blank" rel="noopener">
          {{ t("extra.otherCta") }} <span aria-hidden="true">→</span>
        </a>
      </div>
      <p class="note">{{ t("extra.disclaimer") }}</p>
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { whatsappHref } from "@/data/company";
import { extraServices } from "@/data/packages";

export default {
  name: "ExtraServicesSection",
  setup() {
    const { t } = useI18n();
    const quoteHref = computed(() => whatsappHref(t("contact.waPrefill")));
    function featureList(id) {
      const list = [];
      for (let i = 0; i < 12; i += 1) {
        const key = `extra.items.${id}.features.${i}`;
        const value = t(key);
        if (value === key) break;
        list.push(value);
      }
      return list;
    }
    return { t, extraServices, quoteHref, featureList };
  },
};
</script>
